module.exports = __webpack_public_path__ + "img/truckTrailerRearRight.f762a071.svg";